var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"persistent":"","max-width":"350"},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('BaseBodyDialog',{attrs:{"title":_vm.title},on:{"close":_vm.cancel,"save":_vm.confirm}},[(_vm.message)?_c('div',{staticClass:"mt-4",domProps:{"innerHTML":_vm._s(_vm.message)}}):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }